









import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Market } from '@/modules/neovehicle/models/market';

@Component
export default class extends Vue {
    @Prop()
    public title: boolean;

    @Prop()
    public value: Market;

    @Prop({ default: false })
    public disabled: boolean;

    public money = {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
    };
}
